module.exports = __webpack_public_path__ + "img/sidebar_rl_nord_202627.71174a1d.png";